// @ts-nocheck
/**
 * A/B candidate buy box for the three Ultimate Stack products.
 *
 * Intelligems activates the candidate by setting
 * data-tn-stack-buybox="B" on <html>. Nothing is swapped until the selected
 * Shopify variant and the configured selling-plan allocation are valid.
 */
(function () {
  "use strict";

  if (window.__tnStackSubscribeLayoutLoaded) return;
  window.__tnStackSubscribeLayoutLoaded = true;

  var LEGACY_SELECTOR = [".appstle_sub_widget"].join(",");

  var CHECK_SVG =
    '<svg class="kb-sub__check" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path d="M7.75 14.25 3.5 10l1.375-1.375L7.75 11.5l7.375-7.375L16.5 5.5z" fill="currentColor"/></svg>';

  var INFO_SVG =
    '<svg viewBox="0 0 512 512" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="nonzero" d="M256 0c70.69 0 134.69 28.66 181.02 74.98C483.34 121.3 512 185.31 512 256c0 70.69-28.66 134.7-74.98 181.02C390.69 483.34 326.69 512 256 512c-70.69 0-134.69-28.66-181.02-74.98C28.66 390.69 0 326.69 0 256c0-70.69 28.66-134.69 74.98-181.02C121.31 28.66 185.31 0 256 0zm-9.96 161.03c0-4.28.76-8.26 2.27-11.91 1.5-3.63 3.77-6.94 6.79-9.91 3-2.95 6.29-5.2 9.84-6.7 3.57-1.5 7.41-2.28 11.52-2.28 4.12 0 7.96.78 11.49 2.27 3.54 1.51 6.78 3.76 9.75 6.73 2.95 2.97 5.16 6.26 6.64 9.91 1.49 3.63 2.22 7.61 2.22 11.89 0 4.17-.73 8.08-2.21 11.69-1.48 3.6-3.68 6.94-6.65 9.97-2.94 3.03-6.18 5.32-9.72 6.84-3.54 1.51-7.38 2.29-11.52 2.29-4.22 0-8.14-.76-11.75-2.26-3.58-1.51-6.86-3.79-9.83-6.79-2.94-3.02-5.16-6.34-6.63-9.97-1.48-3.62-2.21-7.54-2.21-11.77zm13.4 178.16c-1.11 3.97-3.35 11.76 3.3 11.76 1.44 0 3.27-.81 5.46-2.4 2.37-1.71 5.09-4.31 8.13-7.75 3.09-3.5 6.32-7.65 9.67-12.42 3.33-4.76 6.84-10.22 10.49-16.31.37-.65 1.23-.87 1.89-.48l12.36 9.18c.6.43.73 1.25.35 1.86-5.69 9.88-11.44 18.51-17.26 25.88-5.85 7.41-11.79 13.57-17.8 18.43l-.1.06c-6.02 4.88-12.19 8.55-18.51 11.01-17.58 6.81-45.36 5.7-53.32-14.83-5.02-12.96-.9-27.69 3.06-40.37l19.96-60.44c1.28-4.58 2.89-9.62 3.47-14.33.97-7.87-2.49-12.96-11.06-12.96h-17.45c-.76 0-1.38-.62-1.38-1.38l.08-.48 4.58-16.68c.16-.62.73-1.04 1.35-1.02l89.12-2.79c.76-.03 1.41.57 1.44 1.33l-.07.43-37.76 124.7zm158.3-244.93c-41.39-41.39-98.58-67-161.74-67-63.16 0-120.35 25.61-161.74 67-41.39 41.39-67 98.58-67 161.74 0 63.16 25.61 120.35 67 161.74 41.39 41.39 98.58 67 161.74 67 63.16 0 120.35-25.61 161.74-67 41.39-41.39 67-98.58 67-161.74 0-63.16-25.61-120.35-67-161.74z"></path></svg>';

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalise(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function replaceToken(value, token, replacement) {
    return String(value || "")
      .split(token)
      .join(replacement);
  }

  function parseConfig(root) {
    var script = root.querySelector("[data-stack-sub-config]");
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || "{}");
    } catch (error) {
      console.error("Stack Subscribe Layout configuration is invalid", error);
      return null;
    }
  }

  function optionIndex(optionNames, wanted) {
    var target = normalise(wanted);
    for (var index = 0; index < optionNames.length; index++) {
      if (normalise(optionNames[index]) === target) return index;
    }
    return -1;
  }

  function optionIndexContaining(optionNames, phrase) {
    var target = normalise(phrase);
    for (var index = 0; index < optionNames.length; index++) {
      if (normalise(optionNames[index]).indexOf(target) !== -1) return index;
    }
    return -1;
  }

  function money(cents, currency, stripZeroDecimals) {
    var amount = Number(cents || 0) / 100;
    var hasDecimals = Math.round(amount * 100) % 100 !== 0;

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
        currencyDisplay: "symbol",
        minimumFractionDigits: stripZeroDecimals && !hasDecimals ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (error) {
      return "$" + amount.toFixed(stripZeroDecimals && !hasDecimals ? 0 : 2);
    }
  }

  function planForVariant(variant, wantedName) {
    var wanted = normalise(wantedName);
    if (!variant || !wanted) return null;

    return (
      (variant.sellingPlans || []).find(function (plan) {
        return normalise(plan.name) === wanted;
      }) || null
    );
  }

  function uniqueOptionValues(variants, index) {
    var seen = {};
    return variants.reduce(function (values, variant) {
      var value = variant.options[index];
      var key = normalise(value);
      if (!key || seen[key]) return values;
      seen[key] = true;
      values.push(value);
      return values;
    }, []);
  }

  function findVariant(state, energyFlavor, shredFlavor) {
    return (
      state.variants.find(function (variant) {
        return (
          normalise(variant.options[state.energyIndex]) ===
            normalise(energyFlavor) &&
          normalise(variant.options[state.shredIndex]) ===
            normalise(shredFlavor)
        );
      }) || null
    );
  }

  function isPurchasable(state, variant) {
    return Boolean(
      variant &&
      variant.available &&
      planForVariant(variant, state.config.sellingPlanName),
    );
  }

  function buildState(host, root, config) {
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var optionNames = Array.isArray(config.options) ? config.options : [];
    var energyIndex = optionIndex(optionNames, config.energyOptionName);
    var shredIndex = optionIndex(optionNames, config.shredOptionName);
    if (energyIndex < 0)
      energyIndex = optionIndexContaining(optionNames, "energy drink");
    if (shredIndex < 0)
      shredIndex = optionIndexContaining(optionNames, "shred");
    var form = host.closest("form[action*='/cart/add']");

    if (
      !variants.length ||
      energyIndex < 0 ||
      shredIndex < 0 ||
      energyIndex === shredIndex ||
      !form
    ) {
      return null;
    }

    var state = {
      root: root,
      host: host,
      form: form,
      config: config,
      variants: variants,
      energyIndex: energyIndex,
      shredIndex: shredIndex,
      energyOptionName: optionNames[energyIndex],
      shredOptionName: optionNames[shredIndex],
      energyValues: uniqueOptionValues(variants, energyIndex),
      shredValues: uniqueOptionValues(variants, shredIndex),
      selectedEnergy: config.defaultEnergyFlavor,
      selectedShred: config.defaultShredFlavor,
      selectedVariant: null,
      selectedPlan: null,
      submittingOneTime: false,
      instanceId:
        "stack-sub-" +
        String(config.productId || "product") +
        "-" +
        Math.random().toString(36).slice(2, 8),
    };

    state.selectedVariant = findVariant(
      state,
      state.selectedEnergy,
      state.selectedShred,
    );
    if (!isPurchasable(state, state.selectedVariant)) {
      state.selectedVariant =
        variants.find(function (variant) {
          return isPurchasable(state, variant);
        }) || null;
    }
    if (!state.selectedVariant) return null;

    state.selectedEnergy = state.selectedVariant.options[energyIndex];
    state.selectedShred = state.selectedVariant.options[shredIndex];
    state.selectedPlan = planForVariant(
      state.selectedVariant,
      config.sellingPlanName,
    );
    return state.selectedPlan ? state : null;
  }

  function selectMarkup(state, kind, label, values, selectedValue) {
    var index = kind === "energy" ? state.energyIndex : state.shredIndex;
    var otherValue =
      kind === "energy" ? state.selectedShred : state.selectedEnergy;
    var otherIndex = kind === "energy" ? state.shredIndex : state.energyIndex;
    var id = state.instanceId + "-" + kind;
    var labelId = id + "-label";
    var menuId = id + "-menu";

    var options = values
      .map(function (value) {
        var variant = state.variants.find(function (candidate) {
          return (
            normalise(candidate.options[index]) === normalise(value) &&
            normalise(candidate.options[otherIndex]) === normalise(otherValue)
          );
        });
        var disabled = !isPurchasable(state, variant);
        var selected = normalise(value) === normalise(selectedValue);
        return (
          '<button type="button" class="kb-sub__flavor-option" data-stack-flavor-option data-flavor-value="' +
          escapeHtml(value) +
          '" role="option" aria-selected="' +
          String(selected) +
          '"' +
          (disabled ? " disabled" : "") +
          "><span>" +
          escapeHtml(value) +
          "</span></button>"
        );
      })
      .join("");

    return (
      '<div class="stack-sub__selector">' +
      '<span class="kb-sub__flavor-label" id="' +
      escapeHtml(labelId) +
      '">' +
      escapeHtml(label) +
      "</span>" +
      '<div class="kb-sub__flavor" data-stack-flavor-dropdown="' +
      kind +
      '">' +
      '<button type="button" class="kb-sub__flavor-trigger" id="' +
      escapeHtml(id) +
      '" aria-haspopup="listbox" aria-expanded="false" aria-controls="' +
      escapeHtml(menuId) +
      '" aria-labelledby="' +
      escapeHtml(labelId) +
      " " +
      escapeHtml(id) +
      '">' +
      '<span class="kb-sub__flavor-value">' +
      escapeHtml(selectedValue) +
      "</span>" +
      "</button>" +
      '<div class="kb-sub__flavor-menu" id="' +
      escapeHtml(menuId) +
      '" role="listbox" hidden>' +
      options +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  function tooltipMarkup(state) {
    var id = state.instanceId + "-pause-tooltip";
    return (
      '<div class="stack-sub__tooltip-wrap">' +
      '<button type="button" class="stack-sub__info-trigger kb-sub-gifts__info-trigger" aria-label="More information about cancelling or pausing" aria-controls="' +
      escapeHtml(id) +
      '" aria-expanded="false" data-stack-tooltip-trigger>' +
      INFO_SVG +
      "</button>" +
      '<div class="kb-sub-gifts__tooltip" id="' +
      escapeHtml(id) +
      '" role="tooltip" hidden data-stack-tooltip>' +
      String(state.config.pauseInformation || "") +
      "</div></div>"
    );
  }

  function render(state) {
    var variant = state.selectedVariant;
    var plan = state.selectedPlan;
    var config = state.config;
    var compareAt = Math.max(
      Number(variant.compareAtPrice || 0),
      Number(variant.price || 0),
    );
    var subscriptionPrice = Number(plan.price || 0);
    var saveAmount = Math.max(0, compareAt - subscriptionPrice);
    var savePercent =
      compareAt > 0 ? Math.round((saveAmount / compareAt) * 100) : 0;
    var priceText = money(subscriptionPrice, config.currency, true);
    var oneTimePrice = money(Number(variant.price || 0), config.currency, true);
    var perDayPrice = money(
      Math.round(subscriptionPrice / 30),
      config.currency,
      true,
    );
    var billing = replaceToken(config.billingLabel, "{price}", priceText);
    var perDay = replaceToken(config.perDayLabel, "{price}", perDayPrice);
    var savePrefix = replaceToken(
      config.saveBenefitPrefix,
      "{percent}",
      savePercent + "%",
    );
    var saveSuffix = replaceToken(
      config.saveBenefitSuffix,
      "{amount}",
      money(saveAmount, config.currency, true),
    );
    var oneTimeLabel = replaceToken(
      config.oneTimeLabel,
      "{price}",
      oneTimePrice,
    );
    var giftTemplate = state.root.querySelector(
      "[data-stack-sub-gifts-template]",
    );
    var gifts = giftTemplate ? giftTemplate.innerHTML : "";

    state.host.innerHTML =
      '<div class="kb-sub kb-sub--variants">' +
      '<p class="kb-sub__heading">' +
      escapeHtml(config.heading) +
      "</p>" +
      '<div class="kb-sub__cards" role="group" aria-label="' +
      escapeHtml(config.heading || "Subscribe & Save") +
      '">' +
      '<div class="kb-sub__card is-selected">' +
      '<div class="kb-sub__main">' +
      '<div class="kb-sub__title-row">' +
      '<span class="kb-sub__radio" aria-hidden="true"></span>' +
      '<span class="kb-sub__title">' +
      escapeHtml(config.supplyTitle) +
      "</span>" +
      '<span class="kb-sub__save kb-sub__save--filled">SAVE ' +
      savePercent +
      "%</span>" +
      "</div>" +
      '<div class="kb-sub__price-row"><span class="kb-sub__price">' +
      escapeHtml(priceText) +
      '</span><span class="kb-sub__mo">/mo</span></div>' +
      '<div class="kb-sub__meta-row"><span class="kb-sub__billed">' +
      escapeHtml(billing) +
      '</span><span class="kb-sub__serving">' +
      escapeHtml(perDay) +
      "</span></div>" +
      '<div class="kb-sub__variants stack-sub__selectors">' +
      selectMarkup(
        state,
        "energy",
        state.energyOptionName,
        state.energyValues,
        state.selectedEnergy,
      ) +
      selectMarkup(
        state,
        "shred",
        state.shredOptionName,
        state.shredValues,
        state.selectedShred,
      ) +
      "</div>" +
      '<ul class="kb-sub__benefits" role="list">' +
      "<li>" +
      CHECK_SVG +
      "<span>" +
      escapeHtml(config.bundleBenefit) +
      "</span></li>" +
      "<li>" +
      CHECK_SVG +
      "<span>" +
      escapeHtml(savePrefix) +
      " — " +
      escapeHtml(saveSuffix) +
      "</span></li>" +
      "<li>" +
      CHECK_SVG +
      "<span>" +
      escapeHtml(config.pauseLabel) +
      "</span>" +
      tooltipMarkup(state) +
      "</li>" +
      "</ul>" +
      gifts +
      "</div>" +
      "</div>" +
      "</div>" +
      '<button type="button" class="kb-sub__onetime" data-stack-one-time><span>' +
      escapeHtml(oneTimeLabel) +
      "</span></button>" +
      "</div>";
  }

  function ensureInput(form, name, marker) {
    var selector = 'input[name="' + name + '"][data-' + marker + "]";
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-" + marker, "");
      form.appendChild(input);
    }
    input.disabled = false;
    return input;
  }

  function syncForm(state, oneTime) {
    var form = state.form;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !state.selectedVariant || (!oneTime && !state.selectedPlan))
      return false;

    idInput.value = String(state.selectedVariant.id);
    idInput.setAttribute("value", String(state.selectedVariant.id));
    idInput.dispatchEvent(new Event("change", { bubbles: true }));

    Array.prototype.forEach.call(
      form.querySelectorAll('input[name="quantity"]'),
      function (input) {
        if (!input.hasAttribute("data-stack-sub-quantity"))
          input.disabled = true;
      },
    );
    var quantityInput = ensureInput(form, "quantity", "stack-sub-quantity");
    quantityInput.value = "1";
    quantityInput.setAttribute("value", "1");

    Array.prototype.forEach.call(
      form.querySelectorAll('[name="selling_plan"]'),
      function (input) {
        if (!input.hasAttribute("data-stack-sub-selling-plan"))
          input.disabled = true;
      },
    );
    var sellingPlanInput = ensureInput(
      form,
      "selling_plan",
      "stack-sub-selling-plan",
    );
    if (oneTime) {
      sellingPlanInput.disabled = true;
      sellingPlanInput.value = "";
      sellingPlanInput.setAttribute("value", "");
      state.host.dataset.selectedSellingPlanId = "";
      state.host.dataset.purchaseMode = "one-time";
    } else {
      sellingPlanInput.disabled = false;
      sellingPlanInput.value = String(state.selectedPlan.id);
      sellingPlanInput.setAttribute("value", String(state.selectedPlan.id));
      state.host.dataset.selectedSellingPlanId = String(state.selectedPlan.id);
      state.host.dataset.purchaseMode = "subscription";
    }
    state.host.dataset.selectedVariantId = String(state.selectedVariant.id);
    state.host.dataset.selectedQuantity = "1";

    return true;
  }

  function selectCombination(state, energyFlavor, shredFlavor) {
    var variant = findVariant(state, energyFlavor, shredFlavor);
    if (!isPurchasable(state, variant)) return false;

    state.selectedEnergy = variant.options[state.energyIndex];
    state.selectedShred = variant.options[state.shredIndex];
    state.selectedVariant = variant;
    state.selectedPlan = planForVariant(variant, state.config.sellingPlanName);
    render(state);
    return syncForm(state, false);
  }

  function closeFlavorMenus(state, except) {
    state.host
      .querySelectorAll("[data-stack-flavor-dropdown].is-open")
      .forEach(function (dropdown) {
        if (dropdown === except) return;
        dropdown.classList.remove("is-open");
        var trigger = dropdown.querySelector(".kb-sub__flavor-trigger");
        var menu = dropdown.querySelector(".kb-sub__flavor-menu");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        if (menu) menu.hidden = true;
      });
  }

  function closeAllFlavorMenus() {
    document
      .querySelectorAll("[data-stack-flavor-dropdown].is-open")
      .forEach(function (dropdown) {
        dropdown.classList.remove("is-open");
        var trigger = dropdown.querySelector(".kb-sub__flavor-trigger");
        var menu = dropdown.querySelector(".kb-sub__flavor-menu");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
        if (menu) menu.hidden = true;
      });
  }

  function tooltipForTrigger(trigger) {
    if (!trigger) return null;
    var tooltipId = trigger.getAttribute("aria-controls");
    if (tooltipId) {
      var controlledTooltip = document.getElementById(tooltipId);
      if (controlledTooltip) return controlledTooltip;
    }
    var wrap = trigger.closest(".stack-sub__tooltip-wrap");
    return wrap && wrap.querySelector("[data-stack-tooltip]");
  }

  function closeTooltip(trigger) {
    var tooltip = tooltipForTrigger(trigger);
    if (!tooltip) return;
    trigger.setAttribute("aria-expanded", "false");
    tooltip.hidden = true;
    tooltip.style.removeProperty("left");
    tooltip.style.removeProperty("top");
    tooltip.style.removeProperty("--kb-sub-tooltip-arrow-left");
    tooltip.removeAttribute("data-placement");
  }

  function closeAllTooltips(exceptTrigger) {
    document
      .querySelectorAll("[data-stack-tooltip-trigger][aria-expanded='true']")
      .forEach(function (trigger) {
        if (trigger !== exceptTrigger) closeTooltip(trigger);
      });
  }

  function positionTooltip(trigger, tooltip) {
    var edge = 16;
    var gap = 10;
    var triggerRect = trigger.getBoundingClientRect();
    var rect = tooltip.getBoundingClientRect();
    var positionContainer = tooltip.offsetParent;
    var containerRect = positionContainer
      ? positionContainer.getBoundingClientRect()
      : { left: 0, top: 0 };
    var viewportWidth = window.visualViewport
      ? window.visualViewport.width
      : document.documentElement.clientWidth;
    var center = triggerRect.left + triggerRect.width / 2;
    var left = Math.min(
      Math.max(center - rect.width / 2, edge),
      Math.max(edge, viewportWidth - rect.width - edge),
    );
    var top = triggerRect.top - rect.height - gap;
    var placement = "top";
    if (top < edge) {
      top = triggerRect.bottom + gap;
      placement = "bottom";
    }
    top = Math.min(
      Math.max(top, edge),
      Math.max(edge, window.innerHeight - rect.height - edge),
    );
    var arrowLeft = Math.min(Math.max(center - left, 12), rect.width - 12);
    tooltip.style.left = Math.round(left - containerRect.left) + "px";
    tooltip.style.top = Math.round(top - containerRect.top) + "px";
    tooltip.style.setProperty(
      "--kb-sub-tooltip-arrow-left",
      Math.round(arrowLeft) + "px",
    );
    tooltip.setAttribute("data-placement", placement);
  }

  function toggleTooltip(trigger) {
    var tooltip = tooltipForTrigger(trigger);
    if (!tooltip) return;
    var open = trigger.getAttribute("aria-expanded") === "true";
    closeAllTooltips(trigger);
    trigger.setAttribute("aria-expanded", open ? "false" : "true");
    tooltip.hidden = open;
    if (!open)
      requestAnimationFrame(function () {
        positionTooltip(trigger, tooltip);
      });
  }

  function bindState(state) {
    if (state.host.dataset.stackBound === "true") return;
    state.host.dataset.stackBound = "true";

    state.host.addEventListener("click", function (event) {
      if (event.target.closest("[data-stack-tooltip]")) return;

      var tooltipTrigger = event.target.closest("[data-stack-tooltip-trigger]");
      if (tooltipTrigger) {
        event.preventDefault();
        toggleTooltip(tooltipTrigger);
        return;
      }

      var flavorOption = event.target.closest("[data-stack-flavor-option]");
      if (flavorOption) {
        event.preventDefault();
        var optionDropdown = flavorOption.closest(
          "[data-stack-flavor-dropdown]",
        );
        var optionKind =
          optionDropdown && optionDropdown.dataset.stackFlavorDropdown;
        var optionValue = flavorOption.dataset.flavorValue;
        var energy =
          optionKind === "energy" ? optionValue : state.selectedEnergy;
        var shred = optionKind === "shred" ? optionValue : state.selectedShred;
        if (!selectCombination(state, energy, shred)) render(state);
        return;
      }

      var flavorTrigger = event.target.closest(".kb-sub__flavor-trigger");
      if (flavorTrigger) {
        event.preventDefault();
        var dropdown = flavorTrigger.closest("[data-stack-flavor-dropdown]");
        var menu = dropdown && dropdown.querySelector(".kb-sub__flavor-menu");
        if (!dropdown || !menu) return;
        var willOpen = !dropdown.classList.contains("is-open");
        closeFlavorMenus(state, dropdown);
        dropdown.classList.toggle("is-open", willOpen);
        flavorTrigger.setAttribute("aria-expanded", String(willOpen));
        menu.hidden = !willOpen;
        return;
      }

      var oneTimeButton = event.target.closest("[data-stack-one-time]");
      if (!oneTimeButton) return;
      event.preventDefault();
      if (!syncForm(state, true)) return;
      state.submittingOneTime = true;
      state.form.requestSubmit();
      window.setTimeout(function () {
        state.submittingOneTime = false;
        syncForm(state, false);
      }, 0);
    });

    state.host.addEventListener("keydown", function (event) {
      if (
        (event.key === "Enter" || event.key === " ") &&
        event.target.matches("[data-stack-tooltip-trigger][role='button']")
      ) {
        event.preventDefault();
        toggleTooltip(event.target);
        return;
      }
      if (event.key === "Escape") {
        var openDropdown = event.target.closest(
          "[data-stack-flavor-dropdown].is-open",
        );
        if (!openDropdown) return;
        var trigger = openDropdown.querySelector(".kb-sub__flavor-trigger");
        closeFlavorMenus(state);
        if (trigger) trigger.focus();
      }
    });

    state.form.__stackSubscribeState = state;
    if (!state.form.dataset.stackSubscribeBound) {
      state.form.dataset.stackSubscribeBound = "true";
      state.form.addEventListener(
        "submit",
        function () {
          var currentState = state.form.__stackSubscribeState;
          if (currentState && !currentState.submittingOneTime)
            syncForm(currentState, false);
        },
        true,
      );
    }
  }

  function scopeFor(root) {
    return (
      root.closest(".shopify-section") ||
      root.closest("[data-section-id]") ||
      root.parentElement
    );
  }

  function removeLegacyWidgets(scope) {
    if (!scope) return;
    scope.querySelectorAll(LEGACY_SELECTOR).forEach(function (node) {
      node.remove();
    });
  }

  function activate(root) {
    if (!root || root.dataset.stackInitialised === "true") return true;
    var host = root.querySelector("[data-stack-sub-layout]");
    var config = parseConfig(root);
    if (!host || !config) return false;

    var state = buildState(host, root, config);
    if (!state) {
      console.warn(
        "Stack Subscribe Layout stayed inactive because the product options, variant, form, or selling plan could not be validated.",
      );
      return false;
    }

    render(state);
    bindState(state);
    if (!syncForm(state, false)) return false;

    var scope = scopeFor(root);
    root.dataset.stackInitialised = "true";
    host.dataset.stackSubActive = "true";
    if (scope) scope.dataset.stackBuyboxActive = "true";
    document.documentElement.dataset.tnStackBuyboxReady = "true";
    root.hidden = false;
    removeLegacyWidgets(scope);
    enableActiveRuntime();
    return true;
  }

  function isVariantB() {
    return (
      normalise(
        document.documentElement.getAttribute("data-tn-stack-buybox"),
      ) === "b"
    );
  }

  function initialiseEligibleRoots(container) {
    var roots = [];
    if (
      container &&
      container.matches &&
      container.matches("[data-stack-sub-root]")
    )
      roots.push(container);
    if (container && container.querySelectorAll) {
      roots = roots.concat(
        Array.prototype.slice.call(
          container.querySelectorAll("[data-stack-sub-root]"),
        ),
      );
    }

    roots.forEach(function (root) {
      var mode = root.dataset.displayMode;
      if (mode === "force" || (mode === "experiment" && isVariantB()))
        activate(root);
    });
  }

  function removeLateLegacyWidgets(node) {
    if (!node || node.nodeType !== 1) return;
    var scope =
      node.closest && node.closest('[data-stack-buybox-active="true"]');
    if (!scope && node.querySelector)
      scope = node.querySelector('[data-stack-buybox-active="true"]');
    if (!scope) return;
    removeLegacyWidgets(scope);
  }

  function enableActiveRuntime() {
    if (window.__tnStackSubscribeActiveRuntime) return;
    window.__tnStackSubscribeActiveRuntime = true;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(removeLateLegacyWidgets);
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener("click", function (event) {
      if (!event.target.closest("[data-stack-flavor-dropdown]"))
        closeAllFlavorMenus();
      if (
        !event.target.closest(
          "[data-stack-tooltip-trigger], [data-stack-tooltip]",
        )
      )
        closeAllTooltips();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      closeAllFlavorMenus();
      var active = document.querySelector(
        "[data-stack-tooltip-trigger][aria-expanded='true']",
      );
      if (!active) return;
      closeAllTooltips();
      active.focus();
    });

    window.addEventListener("resize", function () {
      var trigger = document.querySelector(
        "[data-stack-tooltip-trigger][aria-expanded='true']",
      );
      var tooltip = tooltipForTrigger(trigger);
      if (trigger && tooltip) positionTooltip(trigger, tooltip);
    });
  }

  function start() {
    initialiseEligibleRoots(document);

    new MutationObserver(function () {
      if (isVariantB()) initialiseEligibleRoots(document);
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-tn-stack-buybox"],
    });

    document.addEventListener("shopify:section:load", function (event) {
      initialiseEligibleRoots(event.target);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
